<template>
  <v-flex>
    <div v-if="orderLines.length" class="mb-2">
      <div v-for="(orderLine, i) in orderLines" :key="i">
        <order-line
          v-if="!orderLine.parentOrderLine"
          :orderLine="orderLine"
          :orderLines="orderLines"
          :isPaid="isPaid"
          :currencies="currencies"
          :lastOrderLine="i === orderLines.indexOf(orderLines.filter(o => !o.parentOrderLine).slice(-1).pop())"
        />
      </div>
    </div>
    <v-alert :value="someFreeProduct && !isPaid" color="grey lighten-3" class="grey--text"  transition="scale-transition" mode="in-out">
      <v-layout align-center>
        <v-icon class="mr-2">mdi-alert-circle-outline</v-icon>
        <span class="free-price-alert">{{ $t('activity_reservation.warning.some_product_included') }}</span>
      </v-layout>
    </v-alert>
    <template v-if="amountAndCurrency && amountAndCurrency.amount">
      <v-divider class="mb-4" />
      <v-layout row pl-4 pr-4>
        <span class="product-name primary--text text--darken-1">{{$t('activity_reservation.total')}}</span>
        <v-spacer/>
        <v-layout column align-end justify-center style="font-weight: bold;">
          <template v-if="amountAndCurrency.amount">
            {{ getPriceString({ amountAndCurrency: amountAndCurrency }) }}
            <span v-if="showDisplayCurrency" class="grey--text">
              {{ getPriceString({ amountAndCurrency: amountAndCurrency, displayCurrency: displayCurrency }) }}
            </span>
          </template>
        </v-layout>
      </v-layout>
    </template>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'

import { orderLineItemEntities } from '@/config'

import moneyMixins from '@/mixins/MoneyFormat'

export default {
  props: {
    orderLines: Array,
    totalByCurrencies: Array,
    isPaid: Boolean,
    currencies: Array,
  },
  mixins: [
    moneyMixins,
  ],
  components: {
    OrderLine: () => import('@/components/view-components/catalog/OrderLine.vue'),
  },
  computed: {
    ...mapGetters('me', ['getPriceString', 'showDisplayCurrency', 'displayCurrency']),
    amountAndCurrency () {
      return this.totalByCurrencies[0]
    },
    someFreeProduct () {
      return !!this.orderLines
        .filter(({ itemEntity, price }) => {
          return !price[0].amount &&
            itemEntity === orderLineItemEntities.PRODUCT
        }).length
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .free-price-alert {
    font-weight: 400 !important;
  }
}
</style>
